import { css } from '@emotion/react'
import { Color, Theme, Spacing } from '@opallabs/gem'

export const itemContent = css({
  alignItems: 'center',
  display: 'flex',
  columnGap: Spacing.S,
})

export const selectedItemStyles = (theme: Theme) =>
  css({
    '&[aria-selected=true]': {
      backgroundColor: Color[theme].Translucent.A24,
    },
  })
